import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

// ── Modal Archiver/Réactiver ──
const ModalArchivage = ({ commercial, action, onClose, onSuccess }) => {
  const [commentaire, setCommentaire] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.put(`/commercials/${commercial.id}/${action === "archiver" ? "archiver" : "reactiver"}`, { commentaire });
      onSuccess(`Commercial ${action === "archiver" ? "archivé" : "réactivé"} avec succès !`);
    } catch (err) {
      setError(err.response?.data?.error || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div onClick={e => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "16px", padding: "1.5rem", width: "100%", maxWidth: "400px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ fontSize: "16px", fontWeight: "500", margin: 0, color: action === "archiver" ? "#dc2626" : "#16a34a" }}>
            {action === "archiver" ? "Archiver" : "Réactiver"} {commercial.prenom} {commercial.nom}
          </h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "20px", color: "#6b7280" }}>×</button>
        </div>
        {error && <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", color: "#dc2626", fontSize: "13px" }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "6px" }}>Commentaire</label>
          <textarea value={commentaire} onChange={e => setCommentaire(e.target.value)} placeholder="Raison..." rows={3}
            style={{ width: "100%", padding: "0.75rem 1rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", outline: "none", boxSizing: "border-box", background: "white", resize: "none", marginBottom: "1.25rem" }} />
          <button type="submit" disabled={loading} style={{ width: "100%", padding: "0.75rem", background: action === "archiver" ? "#dc2626" : "linear-gradient(135deg, #16a34a, #22c55e)", color: "white", fontWeight: "500", fontSize: "14px", borderRadius: "9999px", border: "none", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}>
            {loading ? "Traitement..." : action === "archiver" ? "Archiver" : "Réactiver"}
          </button>
        </form>
      </div>
    </div>
  );
};

// ── Modal Modifier Salaire Base ──
const ModalSalaire = ({ commercial, onClose, onSuccess }) => {
  const [salaire, setSalaire] = useState(commercial.salaire_base || 50000);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.put(`/commercials/${commercial.id}/salaire-base`, { salaire_base: parseInt(salaire) });
      onSuccess("Salaire de base mis à jour !");
    } catch (err) {
      setError(err.response?.data?.error || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div onClick={e => e.stopPropagation()} style={{ backgroundColor: "white", borderRadius: "16px", padding: "1.5rem", width: "100%", maxWidth: "380px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
          <h3 style={{ fontSize: "16px", fontWeight: "500", margin: 0 }}>Salaire base — {commercial.prenom} {commercial.nom}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "20px", color: "#6b7280" }}>×</button>
        </div>
        {error && <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", color: "#dc2626", fontSize: "13px" }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "6px" }}>Nouveau salaire de base (F CFA) *</label>
          <input type="number" value={salaire} onChange={e => setSalaire(e.target.value)} required min={0}
            style={{ width: "100%", padding: "0.75rem 1rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "14px", color: "#111827", outline: "none", boxSizing: "border-box", background: "white", marginBottom: "1.25rem" }} />
          <button type="submit" disabled={loading} style={{ width: "100%", padding: "0.75rem", background: "linear-gradient(135deg, #7c3aed, #9333ea)", color: "white", fontWeight: "500", fontSize: "14px", borderRadius: "9999px", border: "none", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}>
            {loading ? "Mise à jour..." : "Confirmer"}
          </button>
        </form>
      </div>
    </div>
  );
};

// ── Page principale ──
const Commerciaux = () => {
  const [commerciaux, setCommerciaux] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [filtre, setFiltre] = useState("tous");
  const navigate = useNavigate();

  const fetchCommerciaux = async () => {
    try {
      const res = await api.get("/commercials/dashboard/admin");
      setCommerciaux(res.data.performance_par_commercial || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCommerciaux();
  }, []);

  const handleSuccess = (msg) => {
    setModal(null);
    setSuccessMsg(msg);
    fetchCommerciaux();
    setTimeout(() => setSuccessMsg(""), 3000);
  };

  const commerciauxFiltres = commerciaux.filter(c => {
    if (filtre === "actifs") return c.actif;
    if (filtre === "archives") return !c.actif;
    return true;
  });

  return (
    <>
      {modal?.type === "archiver" && <ModalArchivage commercial={modal.commercial} action="archiver" onClose={() => setModal(null)} onSuccess={handleSuccess} />}
      {modal?.type === "reactiver" && <ModalArchivage commercial={modal.commercial} action="reactiver" onClose={() => setModal(null)} onSuccess={handleSuccess} />}
      {modal?.type === "salaire" && <ModalSalaire commercial={modal.commercial} onClose={() => setModal(null)} onSuccess={handleSuccess} />}

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.25rem", flexWrap: "wrap", gap: "0.75rem" }}>
        <div>
          <h1 style={{ fontSize: "18px", fontWeight: "500", color: "#111827", margin: 0 }}>Commerciaux</h1>
          <p style={{ fontSize: "13px", color: "#6b7280", margin: "4px 0 0" }}>{commerciaux.length} commercial(aux)</p>
        </div>
        <div style={{ display: "flex", gap: "6px" }}>
          {["tous", "actifs", "archives"].map(f => (
            <button key={f} onClick={() => setFiltre(f)} style={{ padding: "0.4rem 0.9rem", borderRadius: "9999px", fontSize: "12px", border: filtre === f ? "none" : "1px solid #e5e7eb", backgroundColor: filtre === f ? "#7c3aed" : "white", color: filtre === f ? "white" : "#6b7280", cursor: "pointer" }}>
              {f === "tous" ? "Tous" : f === "actifs" ? "Actifs" : "Archivés"}
            </button>
          ))}
        </div>
      </div>

      {successMsg && (
        <div style={{ marginBottom: "1rem", padding: "0.75rem 1rem", backgroundColor: "#f0fdf4", border: "1px solid #86efac", borderRadius: "8px", color: "#16a34a", fontSize: "13px" }}>{successMsg}</div>
      )}

      <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", overflow: "hidden" }}>
        {loading ? (
          <div style={{ padding: "3rem", textAlign: "center", color: "#6b7280" }}>Chargement...</div>
        ) : commerciauxFiltres.length === 0 ? (
          <div style={{ padding: "3rem", textAlign: "center" }}>
            <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>👤</div>
            <p style={{ color: "#6b7280", fontSize: "14px" }}>Aucun commercial</p>
          </div>
        ) : (
          commerciauxFiltres.map((com, i) => (
            <div key={com.id} style={{ padding: "1rem 1.25rem", borderBottom: i < commerciauxFiltres.length - 1 ? "0.5px solid #f3f4f6" : "none", display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
              {/* Avatar */}
              <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: com.actif ? "#E6F1FB" : "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "13px", fontWeight: "500", color: com.actif ? "#185FA5" : "#9ca3af", flexShrink: 0 }}>
                {com.nom?.charAt(0)}{com.prenom?.charAt(0)}
              </div>

              {/* Infos */}
              <div style={{ flex: 1, minWidth: "150px" }}>
                <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827", display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                  {com.prenom} {com.nom}
                  <span style={{ fontSize: "10px", backgroundColor: "#f3e8ff", color: "#7c3aed", padding: "1px 6px", borderRadius: "4px", fontWeight: "500" }}>{com.produit_nom || "Cash24"}</span>
                  {!com.actif && <span style={{ fontSize: "11px", backgroundColor: "#f3f4f6", color: "#6b7280", padding: "1px 6px", borderRadius: "4px" }}>Archivé</span>}
                </div>
                <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "2px" }}>
                  {com.nb_clients} client(s) · {com.nombre_coupons_vendus} coupon(s) · Salaire net : {Number(com.salaire_net_estime).toLocaleString("fr-FR")} F
                </div>
              </div>

              {/* Stats */}
              <div style={{ display: "flex", gap: "1rem", flexShrink: 0 }}>
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "15px", fontWeight: "500", color: "#185FA5" }}>{com.nombre_credits_octroyes}</div>
                  <div style={{ fontSize: "10px", color: "#9ca3af" }}>crédits</div>
                </div>
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "15px", fontWeight: "500", color: com.dette_totale > 0 ? "#dc2626" : "#9ca3af" }}>
                    {com.dette_totale > 0 ? `${Number(com.dette_totale).toLocaleString("fr-FR")} F` : "—"}
                  </div>
                  <div style={{ fontSize: "10px", color: "#9ca3af" }}>dette</div>
                </div>
              </div>

              {/* Actions */}
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                <button onClick={() => navigate(`/admin/commerciaux/${com.id}`)}
                  style={{ padding: "0.4rem 0.9rem", backgroundColor: "#f3e8ff", color: "#7c3aed", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "500", cursor: "pointer" }}>
                  Fiche
                </button>
                <button onClick={() => setModal({ type: "salaire", commercial: com })}
                  style={{ padding: "0.4rem 0.9rem", backgroundColor: "#E6F1FB", color: "#185FA5", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "500", cursor: "pointer" }}>
                  Salaire base
                </button>
                {com.actif ? (
                  <button onClick={() => setModal({ type: "archiver", commercial: com })}
                    style={{ padding: "0.4rem 0.9rem", backgroundColor: "#fef2f2", color: "#dc2626", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "500", cursor: "pointer" }}>
                    Archiver
                  </button>
                ) : (
                  <button onClick={() => setModal({ type: "reactiver", commercial: com })}
                    style={{ padding: "0.4rem 0.9rem", backgroundColor: "#f0fdf4", color: "#16a34a", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "500", cursor: "pointer" }}>
                    Réactiver
                  </button>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default Commerciaux;